import React, { PropsWithChildren, SyntheticEvent } from 'react';
import { Button as DefaultButton, composeStyles, PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { Spinner } from '@components/atoms/Spinner/Spinner';
import { buttonProps } from './props/default';

export interface ButtonProps extends PropsWithChildren, PropsWithClassProps<'button'> {
  hasAction?: boolean;
  title?: string;
  id?: string;
  isLoading?: boolean;
  omit?: boolean;
  onAction?: (evt: SyntheticEvent) => void;
  link?: string;
  disabled?: boolean;
  openInTab?: boolean;
  buttonStyle?: 'primary' | 'secondary' | 'tertiary' | 'viewLink';
  full?: boolean;
  preventDefault?: boolean;
  stopPropagation?: boolean;
  PreElement?: React.ReactNode;
}

export const Button = ({
  title,
  id,
  hasAction,
  isLoading,
  link,
  onAction,
  disabled,
  classProps,
  openInTab,
  buttonStyle = 'secondary',
  omit,
  preventDefault,
  stopPropagation,
  PreElement,
  children,
}: ButtonProps) => {
  const props = buttonProps[buttonStyle];

  return (
    <DefaultButton
      {...props}
      id={id}
      hasAction={hasAction}
      onAction={(evt) => {
        preventDefault && evt.preventDefault();
        stopPropagation && evt.stopPropagation();
        onAction(evt);
      }}
      link={link}
      disabled={disabled}
      openInTab={openInTab}
      omit={omit}
      PreElement={isLoading ? <Spinner iconSize="1em" /> : PreElement || props.PreElement}
      classProps={
        disabled
          ? composeStyles(buttonProps.disabled.classProps, classProps)
          : composeStyles(props.classProps, classProps)
      }
    >
      {children || title}
    </DefaultButton>
  );
};
